import { useEffect } from 'react';

/**
 * Imperative SEO helper for CRA (no SSR).
 * Updates document.title and meta tags to improve link previews & search.
 */
const upsertMeta = (selector, attr, content) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement('meta');
    const [type, value] = selector.replace('meta[', '').replace(']', '').split('=');
    el.setAttribute(type, value.replace(/"/g, ''));
    document.head.appendChild(el);
  }
  el.setAttribute(attr, content);
};

const upsertLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement('link');
    el.setAttribute('rel', rel);
    document.head.appendChild(el);
  }
  el.setAttribute('href', href);
};

export const useSEO = ({ title, description, canonical, image }) => {
  useEffect(() => {
    const previousTitle = document.title;

    if (title) document.title = title;
    if (description) {
      upsertMeta('meta[name="description"]', 'content', description);
      upsertMeta('meta[property="og:description"]', 'content', description);
      upsertMeta('meta[name="twitter:description"]', 'content', description);
    }
    if (title) {
      upsertMeta('meta[property="og:title"]', 'content', title);
      upsertMeta('meta[name="twitter:title"]', 'content', title);
    }
    if (canonical) upsertLink('canonical', canonical);
    if (image) {
      upsertMeta('meta[property="og:image"]', 'content', image);
      upsertMeta('meta[name="twitter:image"]', 'content', image);
    }
    upsertMeta('meta[property="og:type"]', 'content', 'website');
    upsertMeta('meta[name="twitter:card"]', 'content', 'summary_large_image');

    return () => {
      document.title = previousTitle;
    };
  }, [title, description, canonical, image]);
};

export default useSEO;
